import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Common } from 'wsm-common-data';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var validateNonZeroLengthString = function validateNonZeroLengthString(str, name) {
  if (typeof str !== 'string' || str.length === 0) {
    throw new Error("".concat(name, " must be a non-zero length string. Got: ").concat(str, "."));
  }
};
/**
 * Sets the event object for Google anlytics
 * @param {string} widgetName - A string value for widgetName
 * @param {string} widgetId - A string value for widgetId
 * @param {object} trackingObj - An object value for trackingObj
 */


var trackEvent = function trackEvent(widgetName, widgetId, trackingObj) {
  validateNonZeroLengthString(widgetName, 'Widget name');
  validateNonZeroLengthString(widgetId, 'Widget id');
  var isBrowser = typeof window !== 'undefined';

  if (isBrowser) {
    var _window = window,
        _window$DDC = _window.DDC,
        DDC = _window$DDC === void 0 ? {} : _window$DDC;
    var defaultTrackingObj = {
      action: 'clicked',
      element: undefined,
      elementCTA: undefined,
      event: 'widgetUserEvent',
      fieldValue: undefined,
      formEventId: undefined,
      formId: undefined,
      nonInteractive: false,
      result: undefined,
      sourceData: undefined,
      value: undefined,
      widgetId: widgetId,
      widgetName: widgetName,
      widgetState: 'default'
    };

    if (DDC.fireTrackingEvent) {
      DDC.fireTrackingEvent(_objectSpread2$1({}, defaultTrackingObj, {}, trackingObj));
    }

    return !!DDC.fireTrackingEvent;
  }

  return isBrowser;
};

/**
 * getButtons function returns MyCars data objects to be mapped over in order to display
 * MyCars button markup.
 * @param uuid
 * @param isLink
 * @param widgetName
 * @param windowId
 * @param mycarsSaveLabel
 * @param mycarsSavedLabel
 * @param myCarsSaveButtonClasses
 * @returns {*[]}
 */

var getButtons = function getButtons(uuid, isLink, widgetName, windowId, mycarsSaveLabel, mycarsSavedLabel, myCarsSaveButtonClasses) {
  var buttonClasses = new Set(['mycars-btn', 'btn-mycars-save', 'btn-small', 'btn-no-decoration']);

  if (isLink) {
    buttonClasses.add('text-link');
    buttonClasses.add('text-link-muted');
  } else {
    buttonClasses.add('btn');
    buttonClasses.add('btn-default');
  }

  if (myCarsSaveButtonClasses) {
    buttonClasses.add(myCarsSaveButtonClasses);
  }

  var buttonAttributes = {
    'data-id': uuid
  };
  var eventData = {
    element: 'Save button',
    elementCTA: undefined,
    action: 'clicked',
    result: 'Vehicle saved',
    widgetName: widgetName,
    windowId: windowId,
    state: 'default'
  };
  return [{
    id: 'save',
    classes: new Set([].concat(_toConsumableArray(buttonClasses), ['mycars-save-btn'])),
    attributes: _objectSpread2({
      'data-message': '#ddc-mobile-mycars',
      'data-mycars-save': ''
    }, buttonAttributes),
    label: mycarsSaveLabel,
    onClick: function onClick() {
      return trackEvent(eventData.widgetName, eventData.windowId, {
        action: eventData.action,
        element: eventData.element,
        elementCTA: eventData.elementCTA,
        result: eventData.result,
        widgetState: eventData.state
      });
    }
  }, {
    id: 'saved',
    classes: new Set([].concat(_toConsumableArray(buttonClasses), ['hide', 'mycars-saved-btn', 'saved'])),
    attributes: _objectSpread2({
      'data-message': '#ddc-mobile-mycars-remove',
      'data-mycars-remove': ''
    }, buttonAttributes),
    label: mycarsSavedLabel,
    onClick: function onClick() {
      return trackEvent(eventData.widgetName, eventData.windowId, {
        action: eventData.action,
        element: eventData.element,
        elementCTA: eventData.elementCTA,
        result: 'Vehicle unsaved',
        widgetState: 'Saved'
      });
    }
  }];
};

/**
 * Supplies the markup/jsx components for the MyCars buttons.
 *
 * @param {string} uuid Vehicle UUID value
 * @param {boolean} [isLink=false] display as a Bootstrap link style button
 * @param {boolean} [showText=true] display text next to icon
 * @param {string} [mycarsSaveLabel='SAVE'] String label to be used for save button
 * @param {string} [mycarsSavedLabel='SAVED'] String label to be used for saved button
 * @param {string} [myCarsSaveButtonClasses=''] String of classes to be added to the buttons in both states
 * @returns {*} component
 * @constructor
 */

var MyCarsButtons = function MyCarsButtons(_ref) {
  var uuid = _ref.uuid,
      isLink = _ref.isLink,
      showText = _ref.showText,
      mycarsSaveLabel = _ref.mycarsSaveLabel,
      mycarsSavedLabel = _ref.mycarsSavedLabel,
      myCarsSaveButtonClasses = _ref.myCarsSaveButtonClasses;

  var _useSelector = useSelector(function (state) {
    return state.requestData;
  }),
      widgetName = _useSelector.widgetName,
      windowId = _useSelector.windowId;

  var buttons = getButtons(uuid, isLink, widgetName, windowId, mycarsSaveLabel, mycarsSavedLabel, myCarsSaveButtonClasses);
  return React.createElement("div", {
    className: "mycars-buttons wsm-mycars-buttons"
  }, buttons.map(function (button) {
    return React.createElement("button", _extends({
      key: button.id,
      className: _toConsumableArray(button.classes).join(' '),
      onClick: button.onClick
    }, button.attributes, {
      type: "button"
    }), React.createElement("svg", {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      className: "ddc-icon-mycars-favorite"
    }, React.createElement("path", {
      d: "M18.2,22L12,18.2L5.8,22L7,14.5l-5-5l6.9-1.2L12,2l3.2,6.2L22,9.5l-5,5L18.2,22z"
    })), showText && (mycarsSaveLabel !== '' || mycarsSavedLabel !== '') && React.createElement("span", {
      className: "pl-2"
    }, React.createElement(Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(button.label);
      }
    })));
  }));
};

MyCarsButtons.propTypes = {
  uuid: PropTypes.string.isRequired,
  isLink: PropTypes.bool,
  showText: PropTypes.bool,
  mycarsSaveLabel: PropTypes.string,
  mycarsSavedLabel: PropTypes.string,
  myCarsSaveButtonClasses: PropTypes.string
};
MyCarsButtons.defaultProps = {
  isLink: false,
  showText: true,
  mycarsSaveLabel: 'SAVE',
  mycarsSavedLabel: 'SAVED',
  myCarsSaveButtonClasses: ''
};
MyCarsButtons.displayName = 'MyCarsButtons';

export { MyCarsButtons };
//# sourceMappingURL=es.js.map



//////////////////
// WEBPACK FOOTER
// ./~/wsm-mycars-buttons/dist/es.js
// module id = 17
// module chunks = 0